<template>
  <div>
    <nav-bar/>
    <join-banner/>
    <join-product/>
    <join-step/>
    <join-profit/>
    <bottom-footer/>
  </div>
</template>

<script>
import NavBar from 'components/navbar/NavBar'
import JoinBanner from 'views/join/childComps/JoinBanner'
import JoinProduct from 'views/join/childComps/JoinProduct'
import JoinStep from 'views/join/childComps/JoinStep'
import JoinProfit from 'views/join/childComps/JoinProfit'
import BottomFooter from 'components/bottomfooter/BottomFooter.vue'

export default {
  components: {
    NavBar,
    JoinBanner,
    JoinStep,
    JoinProduct,
    BottomFooter,
    JoinProfit
  }
}
</script>

<style scoped>
</style>
